import { useUserContext } from "../contexts";
import Form from "./Form";
import { getResponsibilityFields } from "../utils";
import { useDataContext } from "../contexts";
import { ADMIN } from "../constants";

export default function ResponsibilityAdd({ callback }) {
  const { user } = useUserContext();
  const { memberUsers } = useDataContext();

  const availableTo = user.profileType === ADMIN ? [] : [user.id];

  const responsibilityFields = getResponsibilityFields(memberUsers);

  return (
    <Form
      path="responsibilities"
      fields={responsibilityFields}
      submitCallback={callback}
      initialValues={{
        timesPerWeek: 1,
        family: user.family.id,
        availableTo,
      }}
    />
  );
}
